<template>
  <UserOptions :sortField="sorttingField" :sortOrder="sortOrder" />
  <el-table
    ref="companyusersTableRef"
    id="companyuserstable"
    v-loading="loading"
    :data="companyUsersList"
    style="width: 100%"
    max-height="600px"
    scrollbar-always-on
    :header-cell-style="headerstyle"
    :header-row-style="headerrow"
    :row-style="rowdatastyle"
    @selection-change="handleSelectionChange"
    @sort-change="handleSorting"
    :default-sort="{ prop: 'name', order: 'aescending' }"
    empty-text="No users available"
  >
    <el-table-column type="selection" width="55" />
    <el-table-column label="User Name" prop="name" sortable />
    <el-table-column label="Email" prop="email" sortable />
    <el-table-column label="Assigned Products" sortable>
      <template #default="props">
        <div v-for="(prod, index) in props.row.products" :key="index">
          {{ prod.productName }} {{ prod.majorVersionNumber }}.{{
            prod.minorVersionNumber
          }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Assigned Add-ons" align="center" prop="addOns">
      <template #default="props">
        <div v-for="(addon, index) in props.row.addOns" :key="index">
          {{ addon.productName }} {{ addon.majorVersionNumber }}.{{
            addon.minorVersionNumber
          }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="Status" width="150" prop="userStatus" sortable>
      <template #default="user">
        <img
          src="@/assets/icons/active.svg"
          v-if="user.row.userStatus === 'Active'"
          alt="activeiconimg"
          title="activeiconimg"
        />
        <img
          src="@/assets/icons/idle.svg"
          v-if="user.row.userStatus === 'Idle'"
          alt="idleiconimg"
          title="idleiconimg"
        />
        <img
          src="@/assets/icons/inactive.svg"
          v-if="user.row.userStatus === 'Deleted'"
          alt="inactiveiconimg"
          title="inactiveiconimg"
        />
        <label style="margin-left: 5px">{{ user.row.userStatus }}</label>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagingdiv" v-if="totalPages > 1">
    <label class="pagelabel"
      ><strong>Page {{ currentPage }} / {{ totalPages }}</strong></label
    >
    <el-button
      plain
      class="paginationbtn"
      @click="currentPage = 1"
      id="firstpage"
      :disabled="currentPage === 1"
    >
      <img
        src="@/assets/icons/pagefirstenabled.svg"
        style="width: 20px"
        v-if="currentPage !== 1"
        alt="pagefirstenabledimg"
        title="pagefirstenabledimg"
      />
      <img
        src="@/assets/icons/pagefirstdisabled.svg"
        style="width: 20px"
        v-if="currentPage === 1"
        alt="pagefirstdisabledimg"
        title="pagefirstdisabledimg"
      />
    </el-button>
    <el-pagination
      layout="prev, next"
      :total="totalRowsCount"
      :page-size="10"
      v-model:current-page="currentPage"
    />
    <el-button
      plain
      class="paginationbtn"
      @click="currentPage = totalPages"
      id="lastpage"
      :disabled="currentPage === totalPages"
    >
      <img
        src="@/assets/icons/pagelastenabled.svg"
        style="width: 20px"
        v-if="currentPage !== totalPages"
        alt="pagelastenabledimg"
        title="pagelastenabledimg"
      />
      <img
        src="@/assets/icons/pagelastdisabled.svg"
        style="width: 20px"
        v-if="currentPage === totalPages"
        alt="pagelastdisabledimg"
        title="pagelastdisabledimg"
      />
    </el-button>
  </div>
  <el-dialog
    title="Delete Users"
    v-model="showDeleteDailogue"
    width="35%"
    top="25vh"
    center
  >
    <el-divider></el-divider>
    <div class="text-div">
      <span
        ><strong>{{ getSlectedEmails.length }}</strong> Users selected
      </span>
      <br />
      <span
        >All user data and credential-based licenses will be permanently
        removed.</span
      >
      <span>This action may not be undone.</span>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          id="deleteusercancel"
          @click="showDeleteDailogue = false"
          round
          class="cancelbtn"
          variant="outline-dark"
          >Cancel</el-button
        >
        <el-button
          type="danger"
          @click="deleteUser"
          round
          class="deletebutton"
          id="deleteuserconfirm"
          >Confirm</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<style lang="scss">
.expirationlabel {
  color: #df444d;
  font-size: 14px;
  line-height: 1.53em;
  font-family: "Open Sans";
  font-weight: 400;
}
.usersdivstyle {
  display: flex;
  flex-direction: row-reverse;
}

.comprowstyle {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.el-table--fit .el-table__cell.gutter {
  background: #efefef;
}
</style>
<script lang="ts">
import { defineComponent, nextTick } from "vue";
import APIService from "@/utils/APIService";
import UserOptions from "./UserOptions.vue";
import { mapGetters } from "vuex";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { UserActionTypes } from "@/store/userstore/UserActionTypes";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import { ElMessage, ElTable } from "element-plus";
import _ from "lodash";

export default defineComponent({
  name: "CompanyUsers",
  components: {
    UserOptions,
  },
  computed: {
    ...mapGetters([
      "getCompanyUsers",
      "getCompanyData",
      "getSlectedEmails",
      "getSearchValue",
    ]),
    companyUsersList(): any {
      if (!_.isEmpty(this.getCompanyUsers)) {
        this.updatePaginationData();
      }
      return this.getCompanyUsers.items;
    },
    usrSearchVal: {
      get(): string {
        return this.getSearchValue === ""
          ? this.usrSearcher
          : this.getSearchValue;
      },
      set(val: string) {
        this.usrSearcher = val;
      },
    },
  },
  data() {
    return {
      loading: true,
      showDeleteDailogue: false,
      headerstyle: {
        "border-bottom": "unset",
        background: "#F2F2F2",
        "font-family": "Open Sans, sans-serif",
        "font-weight": "700",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      headerrow: {
        background: "#F2F2F2",
      },
      rowdatastyle: {
        "font-family": "Open Sans, sans-serif",
        "font-weight": "400",
        "font-size": "0.8rem",
        "line-height": "1rem",
        color: "#101010",
      },
      totalRows: 1,
      perPage: 10,
      currentPage: 1,
      pagesNumber: 1,
      totalPages: 0,
      totalRowsCount: 0,
      itemsOnPage: 0,
      sorttingField: 0,
      sortOrder: 0,
      companyUserSelection: [] as any[],
      userSelectionList: [] as any[],
      pagechange: false,
      usrSearcher: "",
    };
  },
  watch: {
    currentPage: function watchForChanges(currPage, prevPage) {
      if (currPage !== prevPage) {
        this.pagechange = true;
        const apiService = new APIService(this.axios);
        const userDataObj = {
          userBucketIdList: null,
          companyBucketIdList: [this.getCompanyData.companyBucketId],
          searchPhrase: null,
          companyName: null,
          pageOptions: {
            skip: currPage - 1,
            take: 10,
            sortField: this.sorttingField,
            sortOrder: this.sortOrder,
          },
        };

        apiService
          .getUsersList(userDataObj)
          .then((res) => {
            this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
            const tableRef = this.$refs.companyusersTableRef as InstanceType<
              typeof ElTable
            >;
            nextTick(() => {
              if (tableRef) {
                this.companyUsersList.forEach((user: any) => {
                  const isSelected = this.companyUserSelection.some(
                    (u) => u.userBucketId === user.userBucketId
                  );
                  tableRef.toggleRowSelection(user, isSelected);
                });
                this.pagechange = false;
              }
            });
          })
          .catch((error) => {
            if (error.code === "ECONNABORTED")
              this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
          });
      }
    },
  },
  methods: {
    checkSearchStr: _.debounce(function (this: any, dataobject: any) {
      const apiService = new APIService(this.axios);
      apiService
        .getUsersList(dataobject)
        .then((res) => {
          this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    }, 1000),
    companyUsersData() {
      const apiService = new APIService(this.axios);
      const userDataObj = {
        userBucketIdList: null,
        companyBucketIdList: [this.getCompanyData.companyBucketId],
        searchPhrase: null,
        companyName: null,
        pageOptions: {
          skip: 0,
          take: 10,
          sortField: null,
          sortOrder: null,
        },
      };
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, []);
      apiService
        .getUsersList(userDataObj)
        .then((res) => {
          this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    updatePaginationData() {
      this.currentPage =
        this.currentPage !== 0
          ? this.currentPage
          : this.getCompanyUsers.pagingData.itemIndex;
      this.totalPages = this.getCompanyUsers.pagingData.totalPages;
      this.totalRowsCount = this.getCompanyUsers.pagingData.itemCount;
    },
    deleteUser() {
      const apiService = new APIService(this.axios);
      const emailData = {
        UserBucketIdCollection: this.getSlectedEmails,
      };
      apiService
        .deleteUsers(emailData)
        .then((res) => {
          if (res.success) {
            const userDataObj = {
              userBucketIdList: null,
              companyBucketIdList: [this.getCompanyData.companyBucketId],
              searchPhrase: null,
              companyName: null,
              pageOptions: {
                skip: this.currentPage - 1,
                take: 10,
                sortField: null,
                sortOrder: null,
              },
            };

            apiService
              .getUsersList(userDataObj)
              .then((resp) => {
                this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, resp);
              })
              .catch((error) => {
                if (error.code === "ECONNABORTED")
                  this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
              });
            this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, []);
            this.showDeleteDailogue = false;
            ElMessage({
              message: "User has been deleted successfully.",
              type: "success",
            });
          } else {
            ElMessage.error(res.validationResult.validationMessages[0]);
          }
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    handleSelectionChange(selected: any) {
      const selectedEmails: any[] = [];
      const addonUsers = [] as any[];
      const userAddons = [] as any[];
      const userBucketIds = [] as any;
      const selectedIdsSet = new Set(selected.map((u: any) => u.userBucketId));
      var checkSelectedList = [] as any[];

      this.companyUsersList.forEach((usercheck: any) => {
        const isSelected = selectedIdsSet.has(usercheck.userBucketId);
        const existingIndex = this.userSelectionList.findIndex(
          (u) => u.userBucketId === usercheck.userBucketId
        );
        if (isSelected) {
          // If row is selected now, mark as selected or add new
          checkSelectedList.push({
            userBucketId: usercheck.userBucketId,
            selected: true,
          });
        } else if (!isSelected && existingIndex !== -1 && !this.pagechange) {
          // If row was previously selected and now is unselected by user
          checkSelectedList.push({
            userBucketId: usercheck.userBucketId,
            selected: false,
          });
        }
      });
      if (selected.length === 0 && checkSelectedList.length !== 0) {
        this.userSelectionList.forEach((user: any) => {
          const matchedCheck = checkSelectedList.find(
            (checkUser: any) => checkUser.userBucketId === user.userBucketId
          );
          user.rowselected = matchedCheck
            ? matchedCheck.selected
            : user.rowselected;
        });
      }
      selected.map((user: any) => {
        const alreadySelected = this.userSelectionList.some(
          (u) => u.userBucketId === user.userBucketId
        );
        if (!alreadySelected) {
          this.userSelectionList.push({
            userPage: this.currentPage,
            rowselected: true,
            ...user,
          });
        } else {
          this.userSelectionList.forEach((user: any) => {
            const matchedCheck = checkSelectedList.find(
              (checkUser: any) => checkUser.userBucketId === user.userBucketId
            );
            user.rowselected = matchedCheck
              ? matchedCheck.selected
              : user.rowselected;
          });
        }
      });
      this.userSelectionList = this.userSelectionList.filter((item) => {
        return item.rowselected;
      });
      this.companyUserSelection = this.userSelectionList;
      this.companyUserSelection.map((item: any) => {
        selectedEmails.push(item.userBucketId);
        if (item.addOns.length !== 0) {
          addonUsers.push(item);
          userBucketIds.push(item.userBucketId);
        }
        item.addOns.map((addon: any) => {
          if (!userAddons.some((item) => item === addon.name))
            userAddons.push(addon);
        });
      });
      this.$store.dispatch(FlowActionTypes.SET_ADDON_USERS, addonUsers);
      this.$store.dispatch(UserActionTypes.SET_USER_ADDONS, userAddons);
      this.$store.dispatch(
        FlowActionTypes.SET_SELECTED_USERS,
        this.companyUserSelection
      );
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, selectedEmails);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERIDS, userBucketIds);
    },
    handleSorting({ prop, order }: { prop: any; order: any }) {
      // eslint-disable-next-line no-nested-ternary
      this.sorttingField =
        prop === "name"
          ? 1
          : prop === "email"
          ? 3
          : prop === "userStatus"
          ? 4
          : prop === "products"
          ? 5
          : 0;
      this.sortOrder = order === "ascending" ? 0 : 1;
      const userDataObj = {
        userBucketIdList: null,
        companyBucketIdList: [
          !_.isEmpty(this.getCompanyData)
            ? this.getCompanyData.companyBucketId
            : "",
        ],
        searchPhrase: null,
        companyName: null,
        pageOptions: {
          skip: this.currentPage - 1,
          take: 10,
          sortField: this.sorttingField,
          sortOrder: this.sortOrder,
        },
      };
      this.loading = true;
      const apiService = new APIService(this.axios);
      apiService
        .getUsersList(userDataObj)
        .then((res) => {
          this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
          this.loading = false;
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
  },
  mounted() {
    this.companyUsersData();
  },
});
</script>
